import { create } from "zustand";

export const useStore = create((set, get) => ({
  loadingProgress: 0,
  setLoadingProgress: (loadingProgress) => set({ loadingProgress }),
  loadingScreen: process.env.NODE_ENV === "development" ? false : true,
  setLoadingScreen: (loadingScreen) => set({ loadingScreen }),
  hasInteracted: false,
  setHasInteracted: (hasInteracted) => set({ hasInteracted }),
  volume: 0,
  setVolume: (volume) => set({ volume }),
  lenis: undefined,
  setLenis: (lenis) => set({ lenis }),
  bowser: undefined,
  setBowser: (bowser) => set({ bowser }),
  platform: undefined,
  setPlatform: (platform) => set({ platform }),
  discoverThreshold: undefined,
  setDiscoverThreshold: (discoverThreshold) => set({ discoverThreshold }),
  isHoveringTerms: false,
  setIsHoveringTerms: (isHoveringTerms) => set({ isHoveringTerms }),
  displayChair: false,
  setDisplayChair: (displayChair) => set({ displayChair }),
  storeEnv: "/textures/env3.hdr",
  setStoreEnv: (storeEnv) => set({ storeEnv }),
}));
